type LoadingDotsProps = {
  color?: string;
};

export default function LoadingDots({ color = '#000' }: LoadingDotsProps) {
  return (
    <span className="inline-flex items-center">
      <span
        className="mx-[1px] inline-block h-[5px] w-[5px] rounded-full animate-pulse"
        style={{ backgroundColor: color, animationDelay: '0s', animationDuration: '1.4s' }}
      />
      <span
        className="mx-[1px] inline-block h-[5px] w-[5px] rounded-full animate-pulse"
        style={{ backgroundColor: color, animationDelay: '0.2s', animationDuration: '1.4s' }}
      />
      <span
        className="mx-[1px] inline-block h-[5px] w-[5px] rounded-full animate-pulse"
        style={{ backgroundColor: color, animationDelay: '0.4s', animationDuration: '1.4s' }}
      />
    </span>
  );
}
